/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Empty_TitleInputs */

const en_portal_scanner_empty_title = /** @type {(inputs: Portal_Scanner_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No scan results yet`)
};

const de_portal_scanner_empty_title = /** @type {(inputs: Portal_Scanner_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No scan results yet`)
};

const fr_portal_scanner_empty_title = /** @type {(inputs: Portal_Scanner_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No scan results yet`)
};

const es_portal_scanner_empty_title = /** @type {(inputs: Portal_Scanner_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No scan results yet`)
};

const it_portal_scanner_empty_title = /** @type {(inputs: Portal_Scanner_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No scan results yet`)
};

const nl_portal_scanner_empty_title = /** @type {(inputs: Portal_Scanner_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No scan results yet`)
};

const pl_portal_scanner_empty_title = /** @type {(inputs: Portal_Scanner_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No scan results yet`)
};

const fi_portal_scanner_empty_title = /** @type {(inputs: Portal_Scanner_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No scan results yet`)
};

const da_portal_scanner_empty_title = /** @type {(inputs: Portal_Scanner_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No scan results yet`)
};

const sv_portal_scanner_empty_title = /** @type {(inputs: Portal_Scanner_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No scan results yet`)
};

/**
* | output |
* | --- |
* | "No scan results yet" |
*
* @param {Portal_Scanner_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_empty_title = /** @type {((inputs?: Portal_Scanner_Empty_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Empty_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_empty_title(inputs)
	if (locale === "fr") return fr_portal_scanner_empty_title(inputs)
	if (locale === "es") return es_portal_scanner_empty_title(inputs)
	if (locale === "it") return it_portal_scanner_empty_title(inputs)
	if (locale === "nl") return nl_portal_scanner_empty_title(inputs)
	if (locale === "pl") return pl_portal_scanner_empty_title(inputs)
	if (locale === "fi") return fi_portal_scanner_empty_title(inputs)
	if (locale === "da") return da_portal_scanner_empty_title(inputs)
	if (locale === "sv") return sv_portal_scanner_empty_title(inputs)
	return en_portal_scanner_empty_title(inputs)
});